var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{attrs:{"gutter":10}},[_c('el-col',{attrs:{"span":14}},[_c('InspectionTable',{attrs:{"orderCode":_vm.orderCode}})],1),_c('el-col',{attrs:{"span":10}},[_c('DocTable',{attrs:{"orderCode":_vm.orderCode}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }